import actions from '@/Core.Service.Domain/Controls/PowerControls/Store/actions.js';
import getters from '@/Core.Service.Domain/Controls/PowerControls/Store/getters.js';
import mutations from '@/Core.Service.Domain/Controls/PowerControls/Store/mutations.js';

const state = {
  powerControlsList: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
